const path = require('path')

module.exports = {
	i18n: {
		defaultLocale: 'en-GB',
		locales: [
			'de-DE',
			'en-AU',
			'en-GB',
			'en-US',
			'es-ES',
			'fr-FR',
			'it-IT',
			'ja-JP',
			'pt-PT',
			'zh-CN',
		],
		localeDetection: false,
	},
	localePath: path.resolve('./public/locales'),
	defaultNS: 'navigation',
	ns: [
		'album',
		'collection',
		'collectionhub',
		'composer',
		'cookiecontrol',
		'download',
		'download-history',
		'homepage',
		'playlist',
		'playlisthub',
		'projectslist',
		'projectview',
		'projectedit',
		'trackrow',
		'addtoproject',
		'favourites',
		'navigation',
		'albums',
		'search',
		'track',
		'app',
		'soundeffects',
		'spotlights',
	],
	fallbackNS: 'app',
}
